import Vue from 'vue'
import Vuex from 'vuex'
import InvoicesModule from './modules/Invoices/InvoicesModule'
import ReleasesModule from './modules/Releases/ReleasesModule'
import ShipmentsModule from './modules/Shipments/ShipmentsModule'
import ReportsModule from './modules/Reports/ReportsModule'
import DocumentsModule from './modules/Documents/DocumentsModule'
import ShippingDocumentModule from './modules/ShippingDocuments/ShippingDocumentModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ReleasesModule,
    ShipmentsModule,
    InvoicesModule,
    ReportsModule,
    DocumentsModule,
    ShippingDocumentModule
  }
})
